// Generated by scripts/fetch-laws.ts from lawsofux.com and timsommer.be. Do not edit directly.
import type { Law } from "../types";

export const kerchkhoffsPrinciple: Law = {
  slug: "kerchkhoffs-principle",
  title: "Kerchkhoff's Principle",
  definition: "In cryptography, a system should be secure even if everything about the system, except for a small piece of information - the key - is public knowledge.",
  category: "theory",
  color: "#ad65be",
  labels: ["security","cs"],
  copy: ["This is the main principle underlying public key cryptography."],
  sources: ["https://www.timsommer.be/famous-laws-of-software-development/"],
  related: [],
};
